export default __webpack_public_path__ + "static/media/4-mobile.371232ca.jpg";